import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface Props {
  /** Куда ведёт стрелка. `-1` — шаг назад по истории (а не новый переход вперёд). */
  to: string | -1
  label: string
}

/** Стрелка «назад» слева от заголовка страницы. */
export const BackButton = ({ to, label }: Props) => {
  const navigate = useNavigate()
  return (
    <button
      type="button"
      onClick={() => (to === -1 ? navigate(-1) : navigate(to))}
      aria-label={label}
      title={label}
      className="flex size-10 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-foreground/5 hover:text-foreground"
    >
      <ArrowLeft className="size-5" />
    </button>
  )
}
